/**
 * UserFindHoldingsUrlDialog — user-facing wrapper around the admin
 * FindHoldingsUrlDialog. Same UI / animations / drop-zone behaviour,
 * but talks to the public API mirrors that don't require admin auth:
 *
 *   GET  /api/holdings-url/lookup/{isin}
 *   POST /api/holdings-url/auto-import/{isin}      (auto providers)
 *   POST /api/wisdomtree-import | invesco-import | lng-import (guided)
 */
import axios from "axios";
import { FindHoldingsUrlDialog } from "./admin/FindHoldingsUrlDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PUBLIC_UPLOAD_ENDPOINTS = {
  WisdomTree: `${API}/wisdomtree-import`,
  Invesco:    `${API}/invesco-import`,
  'L&G':      `${API}/lng-import`,
};
const PUBLIC_LOOKUP_PATH      = `${API}/holdings-url/lookup`;
const PUBLIC_AUTO_IMPORT_PATH = `${API}/holdings-url/auto-import`;

// A bare axios instance — no admin token. `withCredentials` so the user's
// session cookie travels with these gated calls.
const userApi = axios.create({ withCredentials: true });

export function UserFindHoldingsUrlDialog({ open, onClose, onCompleted, initialIsin }) {
  return (
    <FindHoldingsUrlDialog
      open={open}
      onClose={onClose}
      onCompleted={onCompleted}
      apiClient={userApi}
      uploadEndpoints={PUBLIC_UPLOAD_ENDPOINTS}
      lookupPath={PUBLIC_LOOKUP_PATH}
      autoImportPath={PUBLIC_AUTO_IMPORT_PATH}
      initialIsin={initialIsin}
    />
  );
}
